import React, { useState, useEffect } from 'react';
import './styles/styles.scss';
import Background from './components/Background';
import Time from './components/Time';
import Footer from './components/Footer';

export const Theme = React.createContext(null);

function App() {
  const [theme, setTheme] = useState("blue");

  useEffect(() => {
    document.body.style.backgroundColor = theme === "blue" ? "#d4fcff" : "#ffc0fd";
  }, [theme]);

  return (
    <React.Fragment>
      <Theme.Provider value={{ theme: theme, setTheme: setTheme }}>
        <Background />
        <div className="container">
          <Time />
          <Footer />
        </div>
      </Theme.Provider>
    </React.Fragment>
  );
}

export default App;
